/**
 * Chilean Peso (CLP) Price Formatting Utilities
 * 
 * Formats numeric values as Chilean Peso currency.
 * Format: $XXX.XXX CLP (using period as thousands separator)
 */

/**
 * Formats a number as Chilean Peso currency
 * 
 * @param {number} price - The price value to format
 * @returns {string} The formatted price string (e.g., "$150.000 CLP")
 */
export function formatCLP(price) {
  // Handle invalid inputs
  if (typeof price !== 'number' || isNaN(price)) {
    return '$0 CLP';
  }
  
  // Handle negative numbers - format absolute value with negative sign
  const isNegative = price < 0;
  const absolutePrice = Math.abs(price);
  
  // Round to integer (CLP doesn't use decimals)
  const roundedPrice = Math.round(absolutePrice);
  
  // Format with period as thousands separator
  const formattedNumber = roundedPrice
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  // Build final string
  const sign = isNegative ? '-' : '';
  return `${sign}$${formattedNumber} CLP`;
}

export default {
  formatCLP
};
